import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, BlockText, Heading, Panel, Separator } from "@nju/ui";

interface IMySimCardSettingsSuccess {
  userId: string | undefined;
}

export function MySimCardSettingsSuccess({
  userId,
}: IMySimCardSettingsSuccess) {
  return (
    <Panel>
      <Heading
        align="center"
        font="ttfirs"
        tone="neutral"
        variant="h2"
        weight="bold"
      >
        gotowe!
      </Heading>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="sliders-h-incircle"
        />
      </div>
      <Separator size="s" tone="invisible" />
      <BlockText
        align="center"
        size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
      >
        Ustawienia numeru zostały zapisane.
      </BlockText>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col">
        <Link
          href={portalRoutes.mojeKonto.index.get({
            mode: "mobile",
            ...(userId && { userId }),
          })}
          passHref={true}
        >
          <A size={{ "@onlyMobile": "s" }}>ok</A>
        </Link>
      </div>
    </Panel>
  );
}
